import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import legalEntityReadAction from './legalEntityRead.action.json' assert { type: 'json' }

const legalEntityReadDefinition = defineReadAutoAction(legalEntityReadAction, 'legalEntity')

export default legalEntityReadDefinition
